import { useAtom, useSetAtom } from 'jotai';
import { usePostMessage } from '../usePostMessage';
import { flavorAtom, openAtom } from '../../../shared/atoms';
import { usePostHog } from 'posthog-js/react';

const WIPE_IN_DURATION = 500;
const MODAL_ANIMATION_DURATION = WIPE_IN_DURATION / 2;
const MODAL_ANIMATION_DELAY = WIPE_IN_DURATION * 0.9;
const CLOSE_DELAY =
	WIPE_IN_DURATION - MODAL_ANIMATION_DELAY + MODAL_ANIMATION_DURATION;

type EventName = 'ics_dismiss' | 'continue_shopping';

export const useDismiss = () => {
	const dispatchMessage = usePostMessage();
	const setOpen = useSetAtom(openAtom);
	const [flavor] = useAtom(flavorAtom);
	const posthog = usePostHog();
	const delay = flavor === 'modal' ? CLOSE_DELAY : 0;

	return (eventName: EventName = 'ics_dismiss') => () => {
		setOpen(false);

		setTimeout(() => {
			dispatchMessage({
				type: 'ics_dismiss',
				sender: window.origin,
			});

			posthog?.capture(eventName, { delay });
		}, delay);
	};
};
